import React, { useState } from "react";
import video1 from "../../../assets/common/video1.svg";
import GenericModal from "../../common/modals/GenericModal";
import {
  FlexRowBetween,
  GenericDiv,
  MediumFont,
  PopupForm,
  RespFont,
  TextWithPic,
} from "../../common/Style";
import { useHistory } from "react-router-dom";
import ClientRoutes from "../../../navigation/Routes";
import LogoutSpecipic from "../../common/LogOut/LogoutSpecipic";
import Accordion from "react-bootstrap/Accordion";
import { useSelector } from "react-redux";
import { addAlpha } from "../../common/others/Functions";
import users from "../../../assets/common/usersB.svg";
import calendar from "../../../assets/common/calendar.svg";
import logout from "../../../assets/common/logout.svg";

// Custom styles for Accordion
const accordionStyles = `
  .accordion-item {
    border: 1px solid #e0e0e0 !important;
    border-radius: 8px !important;
    margin-bottom: 12px !important;
    background-color: #ffffff !important;
    overflow: hidden;
  }
  .accordion-header button {
    background-color: #ffffff !important;
    border: none !important;
    box-shadow: none !important;
    padding: 16px 20px !important;
    font-size: 15px !important;
    font-weight: 500 !important;
    color: #333 !important;
    font-family: system-ui, -apple-system, sans-serif !important;
  }
  .accordion-header button:not(.collapsed) {
    background-color: #f8f8f8 !important;
    color: #333 !important;
  }
  .accordion-header button:focus {
    box-shadow: none !important;
    border-color: transparent !important;
  }
  .accordion-body {
    padding: 20px !important;
    background-color: #ffffff !important;
    border-top: 1px solid #f0f0f0 !important;
  }
  .accordion-button::after {
    filter: opacity(0.5);
  }
`;

const dict = {
  "סמס ראשון": (
    <PopupForm style={{ width: "100%", padding: "20px 10px" }}>
      <FlexRowBetween>
        ענבר ביטון ואיתי שטרית שמחים להזמינכם לחתונתם!
      </FlexRowBetween>
      <FlexRowBetween>פרטי האירוע ואישור הגעתכם בקישור:</FlexRowBetween>
      <FlexRowBetween>[קישור ספציפי של האורח]</FlexRowBetween>
      <FlexRowBetween>
        במידה וחל שינוי ניתן להיכנס לקישור ולהזין מחדש את תשובתכם.
      </FlexRowBetween>
      <FlexRowBetween>
        במידה והקישור אינו נפתח יש להגיב להודעה זו את מספר המגיעים.
      </FlexRowBetween>
    </PopupForm>
  ),
  "סמס שני": (
    <PopupForm style={{ width: "100%", padding: "20px 10px" }}>
      <FlexRowBetween>
        טרם אישרתם הגעתכם לחתונה של ענבר ביטון ואיתי שטרית.
      </FlexRowBetween>
      <FlexRowBetween>תשובתכם תסייע לנו להערך בהתאם:</FlexRowBetween>
      <FlexRowBetween>[קישור ספציפי של האורח]</FlexRowBetween>
    </PopupForm>
  ),
  "ווצאפ ראשון": (
    <PopupForm style={{ width: "100%", padding: "20px 10px" }}>
      <FlexRowBetween>
        ענבר ביטון ואיתי שטרית שמחים להזמינכם לחתונתם!
      </FlexRowBetween>
      <FlexRowBetween>פרטי האירוע ואישור הגעתכם בקישור:</FlexRowBetween>
      <br />
      <FlexRowBetween>[קישור ספציפי של האורח]</FlexRowBetween>
      <br />
      <FlexRowBetween>
        <MediumFont>ניתן לרשום לנו כאן את מספר המגיעים (1/2/3...)</MediumFont>
      </FlexRowBetween>
      <FlexRowBetween>
        <MediumFont>או השיבו 0 במידה ולא תגיעו.</MediumFont>
      </FlexRowBetween>
      <br />
      <FlexRowBetween>
        <MediumFont>
          במידה ואתם עדיין לא יודעים עדיף שתגיבו 0 כדי שתפסיקו לקבל הודעות
          ושיחות, במידה ותגיעו תוכלו לשלוח תשובה חדשה 🙏
        </MediumFont>
      </FlexRowBetween>
    </PopupForm>
  ),
  "ווצאפ שני": (
    <PopupForm style={{ width: "100%", padding: "20px 10px" }}>
      <FlexRowBetween>
        טרם אישרתם הגעתכם לחתונה של ענבר ביטון ואיתי שטרית.
      </FlexRowBetween>
      <br />
      <FlexRowBetween>״סופיה״ באר שבע 01/06/2022</FlexRowBetween>
      <br />
      <FlexRowBetween>
        <MediumFont>- כתבו לנו את מספר המגיעים (1/2/3...)</MediumFont>
      </FlexRowBetween>
      <br />
      <FlexRowBetween>
        <MediumFont>- אם לא תוכלו להגיע, אנא כתבו "0"</MediumFont>
      </FlexRowBetween>
      <br />
      <FlexRowBetween>
        <MediumFont>
          - במידה ואינכם בטוחים לגבי הגעתכם, אנא כתבו "0" כדי למנוע קבלת הודעות
          נוספות. כמובן שתוכלו לעדכן אותנו בהמשך במידה ותוכלו להגיע 🙏
        </MediumFont>
      </FlexRowBetween>
    </PopupForm>
  ),
  "ווצאפ שלישי": (
    <PopupForm style={{ width: "100%", padding: "20px 10px" }}>
      <FlexRowBetween>לא רוצים לרדוף אחריך בטלפון 😅</FlexRowBetween>
      <br />
      <FlexRowBetween>
        נשמח לדעת אם את/ה מגיע/ה לחתונה של ענבר ביטון ואיתי שטרית.
      </FlexRowBetween>
      <br />
      <FlexRowBetween>בעלי השמחה חייבים להיערך בהתאם 🙏</FlexRowBetween>
    </PopupForm>
  ),
};

// קומפוננט תפריט בורגר
const BurgerMenu = ({
  isOpen,
  onToggle,
  children,
  position = "relative",
  top,
  left,
}) => {
  return (
    <div
      style={{
        position: position,
        zIndex: 1000,
        ...(top && { top }),
        ...(left && { left }),
      }}
    >
      {/* כפתור הבורגר */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
        }}
        style={{
          background: "#fff",
          color: "white",
          border: "none",
          borderRadius: "0px 0px 12px 0px",
          padding: "10px 12px 12px 10px",
          cursor: "pointer",
          fontSize: 14,
          width: "44px",
          height: "44px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          transition: "all 0.3s ease",
        }}
        title="תפריט"
      >
        <div
          style={{
            width: "23px",
            height: "2px",
            background: "#5377bb",
            position: "relative",
            transition: "all 0.3s ease",
            transform: isOpen ? "rotate(45deg)" : "none",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "-7px",
              left: "0",
              width: "100%",
              height: "100%",
              background: "#5377bb",
              transition: "all 0.3s ease",
              opacity: isOpen ? "0" : "1",
            }}
          />
          <div
            style={{
              position: "absolute",
              top: "7px",
              left: "0",
              width: "100%",
              height: "100%",
              background: "#5377bb",
              transition: "all 0.3s ease",
              transform: isOpen ? "rotate(-90deg)" : "none",
            }}
          />
        </div>
      </button>

      {/* תפריט נפתח */}
      {isOpen && (
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            position: "absolute",
            top: "44px",
            left: "0",
            background: "white",
            borderRadius: "12px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
            padding: "16px",
            minWidth: "200px",
            maxHeight: "80vh",
            overflowY: "auto",
            overflowX: "hidden",
            animation: "slideIn 0.3s ease",
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

// קומפוננט פריט תפריט
const MenuItem = ({
  icon,
  text,
  onClick,
  color = "#333",
  disabled = false,
}) => {
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) onClick();
      }}
      disabled={disabled}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        width: "100%",
        padding: "12px 16px",
        background: "transparent",
        border: "none",
        borderRadius: "8px",
        cursor: disabled ? "not-allowed" : "pointer",
        color: disabled ? "#999" : color,
        fontSize: "14px",
        fontWeight: "500",
        transition: "all 0.2s ease",
        opacity: disabled ? 0.6 : 1,
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.currentTarget.style.backgroundColor = "#f5f5f5";
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled) {
          e.currentTarget.style.backgroundColor = "transparent";
        }
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>{icon}</div>
      <span>{text}</span>
    </button>
  );
};

const Instruction = () => {
  const { user, isTal } = useSelector((state) => state.authReducer);

  let history = useHistory();
  const [showLogout, setShowLogout] = useState(false);
  const [isBurgerMenuOpen, setIsBurgerMenuOpen] = useState(false);
  const [what2show, setWhat2show] = useState(null);

  let widthS = window.innerWidth; // 1728

  // Helper component for video buttons
  const VideoButton = ({ href, text }) => (
    <a
      target="_blank"
      rel="noreferrer"
      href={href}
      style={{
        textDecoration: "none",
        display: "block",
        width: "fit-content",
        margin: "12px auto",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "10px 16px",
          borderRadius: "6px",
          backgroundColor: "#f8f8f8",
          border: "1px solid #d0d0d0",
          transition: "all 0.2s ease",
          cursor: "pointer",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#f0f0f0";
          e.currentTarget.style.borderColor = "#b0b0b0";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "#f8f8f8";
          e.currentTarget.style.borderColor = "#d0d0d0";
        }}
      >
        <div
          style={{
            width: "24px",
            height: "24px",
            borderRadius: "4px",
            backgroundColor: "#e0e0e0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M8 5v14l11-7z" fill="#666" />
          </svg>
        </div>
        <span
          style={{
            fontSize: "14px",
            fontWeight: "400",
            color: "#666",
            fontFamily: "system-ui, -apple-system, sans-serif",
          }}
        >
          {text}
        </span>
      </div>
    </a>
  );

  let mandatoryStep = 0;
  const mandatoryNumGuests = ++mandatoryStep;
  const mandatoryNumEditEvent = ++mandatoryStep;
  const mandatoryNumInviter = user.eventType ? ++mandatoryStep : null;
  const mandatoryNumDupes = ++mandatoryStep;

  return (
    <>
      <style>{accordionStyles}</style>
      <div
        style={{
          width: "100%",
          height: `${window.screen.availHeight}px`,
          backgroundColor: "#fafafa",
        }}
      >
        <BurgerMenu
          isOpen={isBurgerMenuOpen}
          onToggle={() => setIsBurgerMenuOpen(!isBurgerMenuOpen)}
          position="fixed"
          top="0"
          left="0"
        >
          <MenuItem
            icon={
              <img
                src={users}
                alt="users"
                style={{
                  width: "20px",
                  height: "20px",
                  filter: "brightness(0) saturate(100%)",
                }}
              />
            }
            text="מוזמנים"
            color="#333"
            onClick={() => {
              history.push(ClientRoutes.User.main);
              setIsBurgerMenuOpen(false);
            }}
          />
          <MenuItem
            icon={
              <img
                src={calendar}
                alt="todos"
                style={{
                  width: "20px",
                  height: "20px",
                  filter: "brightness(0) saturate(100%)",
                }}
              />
            }
            text="לו״ז"
            color="#333"
            onClick={() => {
              history.push(ClientRoutes.User.todos);
              setIsBurgerMenuOpen(false);
            }}
          />
          <MenuItem
            icon={
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
                  fill="#333"
                />
                <path
                  d="M7 7H17V9H7V7ZM7 11H17V13H7V11ZM7 15H14V17H7V15Z"
                  fill="#333"
                />
              </svg>
            }
            text="הזמנה"
            color="#333"
            onClick={() => {
              history.push(ClientRoutes.User.editDetails);
              setIsBurgerMenuOpen(false);
            }}
          />
          <MenuItem
            icon={
              <img
                src={logout}
                alt="logout"
                style={{
                  width: "20px",
                  height: "20px",
                  filter: "brightness(0) saturate(100%)",
                }}
              />
            }
            text="התנתק"
            color="#333"
            onClick={() => {
              setShowLogout(true);
              setIsBurgerMenuOpen(false);
            }}
          />
        </BurgerMenu>

        <a
          target="_blank"
          rel="noreferrer"
          href={"https://wedding-harmony-2587b071.base44.app/"}
          style={{
            textDecoration: "none",
            display: "block",
            width: "fit-content",
            margin: "24px auto 16px",
          }}
        >
          <div
            style={{
              padding: "14px 32px",
              borderRadius: "8px",
              background:
                "linear-gradient(135deg, #e8f0f8 0%, #f0f5fa 50%, #e8f0f8 100%)",
              border: "1px solid #c8d8e8",
              transition: "all 0.3s ease",
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(123, 150, 196, 0.15)",
              minWidth: "200px",
              textAlign: "center",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background =
                "linear-gradient(135deg, #d8e8f8 0%, #e8f0fa 50%, #d8e8f8 100%)";
              e.currentTarget.style.borderColor = "#b0c8d8";
              e.currentTarget.style.boxShadow =
                "0 4px 12px rgba(123, 150, 196, 0.25)";
              e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background =
                "linear-gradient(135deg, #e8f0f8 0%, #f0f5fa 50%, #e8f0f8 100%)";
              e.currentTarget.style.borderColor = "#c8d8e8";
              e.currentTarget.style.boxShadow =
                "0 2px 8px rgba(123, 150, 196, 0.15)";
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            <span
              style={{
                fontSize: "16px",
                fontWeight: "600",
                color: "#5377bb",
                fontFamily: "system-ui, -apple-system, sans-serif",
              }}
            >
              תיאום ציפיות
            </span>
          </div>
        </a>

        <Accordion
          defaultActiveKey="0"
          style={{
            maxWidth: "800px",
            margin: "0 auto",
            padding: "0 20px",
          }}
        >
          <div
            style={{
              textAlign: "center",
              margin: "32px auto 24px",
              fontSize: "20px",
              fontWeight: "500",
              color: "#333",
              fontFamily: "system-ui, -apple-system, sans-serif",
            }}
          >
            סרטוני חובה
          </div>
          <div
            style={{
              textAlign: "center",
              margin: "0 auto 24px",
              maxWidth: "640px",
              padding: "0 20px",
              fontSize: "15px",
              fontWeight: "500",
              color: "#444",
              lineHeight: 1.65,
              direction: "rtl",
              fontFamily: "system-ui, -apple-system, sans-serif",
            }}
          >
            סרטוני החובה חייבים להתקיים לפי הסדר — יש לצפות ולבצע לפי המספרים
            בכותרות, בלי לדלג על שלב.
          </div>
          <Accordion.Item eventKey="3">
            <Accordion.Header>
              <div
                style={{
                  fontSize: "15px",
                  fontWeight: "500",
                  color: "#333",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                }}
              >
                {mandatoryNumGuests}. הוספת אורחים למערכת
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <div
                style={{
                  fontWeight: "600",
                  fontSize: "15px",
                  color: "#333",
                  marginBottom: "16px",
                  padding: "12px",
                  backgroundColor: "#f8f8f8",
                  borderRadius: "6px",
                  border: "1px solid #e0e0e0",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  lineHeight: "1.6",
                }}
              >
                חשוב מאוד להבין שכאשר אתם מוסיפים אנשים למערכת אולי אתם מזהים
                אותם לפי כינוי אבל ברגע ההושבה שדיילת מחפשת אותם במערכת היא
                לעולם לא תמצא 🤣😂, אז במידה ואתם עושים הושבה יש לרשום את שם
                האורח כפי שהוא, כמובן שגם אם הוספתם מישהו עם כינוי תוכלו אחרי זה
                לעבור ולשנות - יש לשים לב לנושא הזה.
              </div>
              <div
                style={{
                  fontSize: "14px",
                  color: "#555",
                  marginBottom: "12px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  lineHeight: "1.6",
                }}
              >
                ישנן מספר דרכים להוסיף אורחים למערכת, ניתן גם לשלב במספר דרכים.
              </div>
              <div
                style={{
                  fontSize: "14px",
                  color: "#555",
                  marginBottom: "16px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  lineHeight: "1.6",
                }}
              >
                יש להוסיף את האורחים עד תחילת העבודה שלנו שמוצג בתפריט, לו״ז,
                כמובן שגם לאורך התהליך ניתן להוסיף אורחים באופן חופשי
              </div>
              <div
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  fontSize: "14px",
                  color: "#666",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                }}
              >
                ניתן להוסיף ישירות מאנשי הקשר (ניתן להתחבר ממספר מכשירים שונים)
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  marginTop: "16px",
                }}
              >
                <VideoButton
                  href="https://youtube.com/shorts/cPhl7RYS0jM?feature=share"
                  text="אייפון"
                />
                <VideoButton
                  href="https://youtube.com/shorts/BpjPRP9mK48?feature=share"
                  text="אנדרואיד"
                />
              </div>
              <div
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  fontSize: "14px",
                  color: "#666",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                }}
              >
                או להקליד ידנית (אחד אחד) ישירות למערכת, או לאקסל
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  marginTop: "16px",
                }}
              >
                <VideoButton href="https://youtu.be/4oVnHWCLNy8" text="אקסל" />
                <VideoButton
                  href="https://youtu.be/4h9PZpL8Gv8"
                  text="הקלדה ידנית"
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>
              <div
                style={{
                  fontSize: "15px",
                  fontWeight: "500",
                  color: "#333",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                }}
              >
                {mandatoryNumEditEvent}. עריכת פרטי האירוע
              </div>
            </Accordion.Header>
            <Accordion.Body style={{ padding: "20px" }}>
              <div
                style={{
                  fontSize: "14px",
                  color: "#555",
                  marginBottom: "16px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  lineHeight: "1.6",
                }}
              >
                מעבר לפרטים יבשים על האירוע ישנם דברים נוספים שמומלץ לראות
              </div>
              <VideoButton href="https://youtu.be/6i9wEdwPLWs" text="סרטון" />
            </Accordion.Body>
          </Accordion.Item>
          {user.eventType && (
            <Accordion.Item eventKey="2">
              <Accordion.Header>
                <div
                  style={{
                    fontSize: "15px",
                    fontWeight: "500",
                    color: "#333",
                    fontFamily: "system-ui, -apple-system, sans-serif",
                  }}
                >
                  {mandatoryNumInviter}. עריכת מזמין + קשר, חובת צפיה!
                </div>
              </Accordion.Header>
              <Accordion.Body style={{ padding: "20px" }}>
                <div
                  style={{
                    fontSize: "14px",
                    color: "#555",
                    marginBottom: "12px",
                    fontFamily: "system-ui, -apple-system, sans-serif",
                    lineHeight: "1.6",
                  }}
                >
                  חלק גדול מהמוזמנים לחתונה אינם ישירים של הכלה והחתן
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    color: "#555",
                    marginBottom: "12px",
                    fontFamily: "system-ui, -apple-system, sans-serif",
                    lineHeight: "1.6",
                  }}
                >
                  ברירת המחדל של תחילת ההודעה הינה עם שמות הזוג
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    color: "#555",
                    marginBottom: "12px",
                    fontFamily: "system-ui, -apple-system, sans-serif",
                    lineHeight: "1.6",
                  }}
                >
                  ניתן, רצוי, מרשים, מכבד ומעלה משמעותית את המענה לשנות את
                  ההקדמה בכל הודעה
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    color: "#555",
                    marginBottom: "16px",
                    fontFamily: "system-ui, -apple-system, sans-serif",
                    lineHeight: "1.6",
                  }}
                >
                  צפו בסרטון ועשו משהו פשוט שיתרום המון 🙏
                </div>
                <VideoButton href="https://youtu.be/HRx9ewK3pHY" text="סרטון" />
              </Accordion.Body>
            </Accordion.Item>
          )}

          <Accordion.Item eventKey="5">
            <Accordion.Header>
              <div
                style={{
                  fontSize: "15px",
                  fontWeight: "500",
                  color: "#333",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                }}
              >
                {mandatoryNumDupes}. כפולים + ללא מספר + חינמיים
              </div>
            </Accordion.Header>
            <Accordion.Body style={{ padding: "20px" }}>
              <div
                style={{
                  fontSize: "14px",
                  color: "#555",
                  marginBottom: "16px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  lineHeight: "1.6",
                }}
              >
                מומלץ לצפות
              </div>
              <VideoButton href="https://youtu.be/i2flhaDAyNc" text="סרטון" />
            </Accordion.Body>
          </Accordion.Item>

          <div
            style={{
              textAlign: "center",
              margin: "32px auto 24px",
              fontSize: "20px",
              fontWeight: "500",
              color: "#333",
              fontFamily: "system-ui, -apple-system, sans-serif",
            }}
          >
            הסברים נוספים
          </div>

          <Accordion.Item eventKey="iaplan-extra">
            <Accordion.Header>
              <div
                style={{
                  fontSize: "15px",
                  fontWeight: "500",
                  color: "#333",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                }}
              >
                אייפלאן
              </div>
            </Accordion.Header>
            <Accordion.Body style={{ padding: "20px" }}>
              <VideoButton href="https://youtu.be/ZgPH7r1t9VA" text="סרטון" />
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="4">
            <Accordion.Header>
              <div
                style={{
                  fontSize: "15px",
                  fontWeight: "500",
                  color: "#333",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                }}
              >
                תיקונים לאחר שיחות
              </div>
            </Accordion.Header>
            <Accordion.Body style={{ padding: "20px" }}>
              <div
                style={{
                  fontSize: "14px",
                  color: "#555",
                  marginBottom: "16px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  lineHeight: "1.6",
                }}
              >
                בכל פעם שמסתיים סבב שיחות יש לבצע את מה שמוסבר בסרטון הבא:
              </div>
              <VideoButton href="https://youtu.be/hVZ_Lu1kaRI" text="סרטון" />
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="9">
            <Accordion.Header>
              <div
                style={{
                  fontSize: "15px",
                  fontWeight: "500",
                  color: "#333",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                }}
              >
                לא למחוק אורחים!
              </div>
            </Accordion.Header>
            <Accordion.Body style={{ padding: "20px" }}>
              <div
                style={{
                  fontSize: "14px",
                  color: "#555",
                  marginBottom: "12px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  lineHeight: "1.6",
                }}
              >
                1. כולם מקבלים הודעות תזכורת ואולי מישהו שלא מגיע ישאיר בכל זאת
                מתנה באשראי.
              </div>
              <div
                style={{
                  fontSize: "14px",
                  color: "#555",
                  marginBottom: "12px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  lineHeight: "1.6",
                }}
              >
                2. אולי ישנה את דעתו בעקבות הודעת התזכורת וכן יחליט להגיע.
              </div>
              <div
                style={{
                  fontSize: "14px",
                  color: "#555",
                  marginBottom: "12px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  lineHeight: "1.6",
                }}
              >
                3. לאחר האירוע אתם תמלאו מתנות במערכת והיא תייצא לכם אקסל להמשך
                החיים וכן אתם רוצים שבאקסל זה יהיו גם אלה שהזמנתם ולא הגיעו כדי
                שתדעו אתם והמשפחות בעתיד איך להחזיר.
              </div>
              <div
                style={{
                  fontSize: "14px",
                  color: "#555",
                  marginBottom: "12px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  lineHeight: "1.6",
                }}
              >
                4. אם כבר התחלנו אישורי הגעה והם קיבלו סבב אז במילא הם נחשבים
                בתשלום...
              </div>
            </Accordion.Body>
          </Accordion.Item>
          {user.isDigitalSeat && (
            <Accordion.Item eventKey="10">
              <Accordion.Header>
                <div
                  style={{
                    fontSize: "15px",
                    fontWeight: "500",
                    color: "#333",
                    fontFamily: "system-ui, -apple-system, sans-serif",
                  }}
                >
                  הושבה
                </div>
              </Accordion.Header>
              <Accordion.Body style={{ padding: "20px" }}>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#333",
                    marginBottom: "12px",
                    fontFamily: "system-ui, -apple-system, sans-serif",
                    lineHeight: "1.6",
                  }}
                >
                  לפני שבכלל ניגשים להושבה יש לפנות למנהל ההושבה לעצות ודגשים
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    color: "#555",
                    marginBottom: "12px",
                    fontFamily: "system-ui, -apple-system, sans-serif",
                    lineHeight: "1.6",
                  }}
                >
                  לראות מהתחלה ועד הסוף!
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    color: "#555",
                    marginBottom: "16px",
                    fontFamily: "system-ui, -apple-system, sans-serif",
                    lineHeight: "1.6",
                  }}
                >
                  במידה ואתם חדים תשימו על מהירות 1.5 אבל לא לדלג כי כל שאלה
                  שעלולה לעלות לכם - התשובה נמצאת בסרטון
                </div>
                <VideoButton href="https://youtu.be/9XtAbFdrSZg" text="סרטון" />
              </Accordion.Body>
            </Accordion.Item>
          )}
          {user.separation && (
            <Accordion.Item eventKey="11">
              <Accordion.Header>
                <div
                  style={{
                    fontSize: "15px",
                    fontWeight: "500",
                    color: "#333",
                    fontFamily: "system-ui, -apple-system, sans-serif",
                  }}
                >
                  פיצול של המינים לשם הושבה נפרדת
                </div>
              </Accordion.Header>
              <Accordion.Body style={{ padding: "20px" }}>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#333",
                    marginBottom: "16px",
                    fontFamily: "system-ui, -apple-system, sans-serif",
                    lineHeight: "1.6",
                  }}
                >
                  במידה ורשומה אישרה מ 2 המינים נרצה לפצל ל 2 רשומות שונות על
                  מנת להושיב את הגבר בשולחן כלשהו ואת האישה בשולחן אחר
                </div>
                <VideoButton href="https://youtu.be/Snk5FDm6x90" text="סרטון" />
              </Accordion.Body>
            </Accordion.Item>
          )}
          <Accordion.Item eventKey="12">
            <Accordion.Header>
              <div
                style={{
                  fontSize: "15px",
                  fontWeight: "500",
                  color: "#333",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                }}
              >
                עריכת קירבה מרובה
              </div>
            </Accordion.Header>
            <Accordion.Body style={{ padding: "20px" }}>
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#333",
                  marginBottom: "16px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  lineHeight: "1.6",
                }}
              >
                בבת אחת ניתן לבחור קבוצה שלמה/מספר רשומות ולשנות את
                הקירבה/קטגוריה
              </div>
              <VideoButton
                href="https://youtube.com/shorts/eO8kCrk--UI?feature=share"
                text="סרטון"
              />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="13">
            <Accordion.Header>
              <div
                style={{
                  fontSize: "15px",
                  fontWeight: "500",
                  color: "#333",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                }}
              >
                מחיקה מרובה
              </div>
            </Accordion.Header>
            <Accordion.Body style={{ padding: "20px" }}>
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#333",
                  marginBottom: "16px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  lineHeight: "1.6",
                }}
              >
                בבת אחת ניתן למחוק קבוצה שלמה/מספר רשומות
              </div>
              <VideoButton
                href="https://youtube.com/shorts/3QxmEha60sw?feature=share"
                text="סרטון"
              />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <div style={{ height: widthS > 768 ? "20px" : "200px" }}></div>

        {what2show && (
          <GenericModal init={setWhat2show} div={dict[what2show]} />
        )}

        {showLogout && (
          <GenericModal
            init={setShowLogout}
            div={<LogoutSpecipic init={setShowLogout} />}
          />
        )}
      </div>
    </>
  );
};

export default Instruction;
